import EduTeacherLoginPage from "../../platforms/edu/pages/EduTeacherLoginPage";
import CampusLogo from "../../assets/logos/Campus-Logo.png";
import CampusBackground from "../../assets/backgrounds/Campus-Background.png";

export default function TeacherLoginPage() {
  return (
    <EduTeacherLoginPage
      destinationPath="/campus/teacher"
      loginPath="/campus/teacher/login"
      titleFallback="Find your school"
      schoolCodeLabel="School Code"
      lookupButtonLabel="Continue"
      lookupLoadingLabel="Finding School..."
      showStandaloneStudentDevices={false}
      fallbackLogo={CampusLogo}
      fallbackLogoAlt="Oikos Campus"
      useAccountLogo={false}
      defaultBackground={{
        imageUrl: CampusBackground,
        color: "#fff7ed",
      }}
      themeColorOverride="#E86A1F"
      logoFrameStyle={{ height: 128, width: 360, maxWidth: "96%" }}
      logoImageStyle={{ objectFit: "contain" }}
    />
  );
}
